import logoWebp from "@/assets/zaibify-logo.webp";
import { cn } from "@/lib/utils";

type BrandLogoProps = {
  className?: string;
  imgClassName?: string;
  priority?: boolean;
};

const BrandLogo = ({ className, imgClassName, priority = false }: BrandLogoProps) => {
  return (
    <div className={cn("inline-flex items-center", className)}>
      <img
        src={logoWebp}
        alt="Zaibify Digital Solutions logo"
        width={40}
        height={40}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        {...(priority ? { fetchPriority: "high" as const } : {})}
        className={cn("h-10 w-10 object-cover rounded-full", imgClassName)}
      />
    </div>
  );
};

export default BrandLogo;
